import { CLEAR_ERROR_REGEX } from './regex';

export const clearError = (error?: string) =>
  error?.match(CLEAR_ERROR_REGEX)?.[0];

export const isMaxFileSizeUploadError = (error: Error) =>
  error.message?.includes('A imagem excede o tamanho permitido');

export const getMaxFileSizeUploadErrorText = () =>
  'get-max-file-size-upload-error-text-translation-key';

export const getFileUploadErrorText = () =>
  'get-file-upload-error-text-translation-key';

export const getUnfollowUserErrorText = () =>
  'get-unfollow-user-error-text-translation-key';
